<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
    <!--<h1 class="mui-title">外注管理</h1>-->
  <!--</header>-->

    <div class="mui-content">
      <!--第一行-->
      <div class="mui-row border-1" style="height: 44px;">
        <div class="mui-col-xs-6 mui-col-sm-6">
          <img src="static/images/logo.png" alt="" height="44"/>
        </div>
        <div class="mui-col-xs-6 mui-col-sm-6 mui-text-right" style="height: 40px;line-height: 40px;padding-right: 8px;">
          <span class="mui-icon mui-icon-person"></span>
          <a style="color: #1F6FB5;margin-right: 3px;margin-left: 4px;font-family: 'Microsoft YaHei';">{{uname}}</a>

        </div>
      </div>
      <!--第二行轮播-->
      <div class="mui-slider" style="margin-top: 2px;">
        <div class="mui-slider-group mui-slider-loop">
          <div class="mui-slider-item mui-slider-item-duplicate">
            <a href="#"><img src="static/images/2.jpg" /></a>
          </div>
          <!--第一个内容区容器-->
          <div class="mui-slider-item">
            <a href="#"><img src="static/images/2.jpg" /></a>
          </div>
          <!--第二个内容区-->
          <!-- <div class="mui-slider-item">
            <a href="#"><img src="static/images/1.png" /></a>
          </div> -->
          <!--第3个内容区-->
          <!-- <div class="mui-slider-item">
            <a href="#"><img src="static/images/3.jpg" /></a>
          </div>
          <div class="mui-slider-item mui-slider-item-duplicate">
            <a href="#"><img src="static/images/2.jpg" /></a>
          </div> -->
        </div>
        <div class="mui-slider-indicator">
          <div class="mui-indicator mui-active"></div>
          <!--<div class="mui-indicator"></div>
          <div class="mui-indicator"></div> -->
        </div>

      </div>
      <!--第三行功能-->
      <div class="mui-row" style="padding-top: 0px;margin-top: 0px;">
        <h5 style="" class="word-font  title-h5">
          功能
        </h5>
        <div class="mui-row">
          <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle" id="orderbtn" @tap.stop.prevent="toOrderList" >
                <span class="badge" v-if="ordercnt >0 && is_tsd == '0'">{{ordercnt}}</span>
                <span class="icon iconfont">&#xe712;</span>
                <div>
                  <span>订单</span>
                </div>
              </div>
            </div>
          </div>
          <!--原料-->
          <!--<div class="mui-col-sm-4 mui-col-xs-4">-->
          <!--<div class="pd-8">-->
          <!--<div class="circle" id="rowbtn" @tap.stop.prevent="toMaterial">-->
          <!--&lt;!&ndash;<span class="span-content">原料</span>&ndash;&gt;-->
          <!--<img src="static/images/yuanliao.png" />-->
          <!--<div>-->
          <!--<span>原料</span>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <div class="mui-col-sm-4 mui-col-xs-4" v-show="(is_tsd == 0)">
            <div class="pd-8">
              <div class="circle" id="samplingbtn" @tap.stop.prevent="toSampling">
                <span class="icon iconfont">&#xe713;</span>
                <div>
                  <span>取样判定</span>
                </div>
              </div>
            </div>
          </div>
<!--           <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle" id="samplingweaving" @tap.stop.prevent="toSamplingWeaving">
                <img src="static/images/quyangbianzhi.png" alt="">
                <div>
                  <span>取样编织</span>
                </div>
              </div>
            </div>
          </div> -->
          <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle" @tap.stop.prevent="toQuality">
                <span class="icon iconfont">&#xe70e;</span>
                <div>
                  <span>质检标签</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mui-col-sm-4 mui-col-xs-4" v-show="(is_tsd == 0)">
            <div class="pd-8">
              <div class="circle" id="deliverybtn" @tap.stop.prevent="toDelivery">
                <span class="icon iconfont">&#xe715;</span>
                <div>
                  <span>发货管理</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle"  @tap.stop.prevent="toWeChat">
                <img src="static/images/yuanliao.png" />
                <div>
                <span>工作联络</span>
                </div>
              </div>
            </div>
          </div> -->
          <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle"  @tap.stop.prevent="chgPwd">
                <span class="icon iconfont">&#xe714;</span>
                <div>
                <span>修改密码</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mui-col-sm-4 mui-col-xs-4">
            <div class="pd-8">
              <div class="circle" @tap.stop.prevent="toReprintLabel">
                 <span class="icon iconfont">&#xe710;</span>
                <div>
                  <span>标签补打</span>
                </div>
              </div>
            </div>
          </div>
					<!--<div class="mui-col-sm-4 mui-col-xs-4" v-show="(is_tsd == 0 && bzflg)">
					  <div class="pd-8">
					    <div class="circle" @tap.stop.prevent="toYarn">
					       <span class="icon iconfont">&#xe711;</span>
					      <div>
					        <span>挂纱操作</span>
					      </div>
					    </div>
					  </div>
					</div>
					<div class="mui-col-sm-4 mui-col-xs-4" v-show="(is_tsd == 0 && bzflg)">
					  <div class="pd-8">
					    <div class="circle" @tap.stop.prevent="toYarnHis">
					      <span class="icon iconfont">&#xe70f;</span>
					      <div>
					        <span>挂/换纱履历</span>
					      </div>
					    </div>
					  </div>
					</div>-->
					<div class="mui-col-sm-4 mui-col-xs-4" v-show="(is_tsd == 0 && bzflg) || (is_tsd == 1 && hasBZ == '1')">
					  <div class="pd-8">
					    <div class="circle" @tap.stop.prevent="toCheckMachine">
					       <span class="icon iconfont">&#xe716;</span>
					      <div>
					        <span>巡台记录</span>
					      </div>
					    </div>
					  </div>
					</div>

					<div class="mui-col-sm-4 mui-col-xs-4" >
					  <div class="pd-8">
					    <div class="circle" @tap.stop.prevent="toTestQuality">
					       <span class="icon iconfont">&#xe70e;</span>
					      <div>
					        <span>试验反标签</span>
					      </div>
					    </div>
					  </div>
					</div>
        </div>
      </div>

      <div class="backLine" v-if="weaveflg"></div>

      <div class="mui-row iconStatus1" style="padding-top:4px" v-if="weaveflg">
        <div class="mui-col-sm-4 mui-col-xs-4">
          <div class="pd-8">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWarpingHistory">
              <span class="icon iconfont">&#xe794;</span>
              <div>
                <span>整经履历</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="backLine" v-if="weaveflg"></div>
      <div class="mui-row iconStatus2" style="padding-top:4px;padding-bottom:10px;" v-if="weaveflg">
        <div class="mui-col-sm-4 mui-col-xs-4">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toEditHistory">
              <span class="icon iconfont">&#xe799;</span>
              <div>
                <span>丸编操作履历</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWeaveEnter('1')">
              <span class="icon iconfont">&#xe796;</span>
              <div>
                <span>丸编挂纱</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWeaveEnter('20')">
              <span class="icon iconfont">&#xe7ae;</span>
              <div>
                <span>丸编换纱</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWeaveEnter('2')">
              <span class="icon iconfont">&#xe798;</span>
              <div>
                <span>丸编挑纱</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWeaveEnter('3')">
              <span class="icon iconfont">&#xe79a;</span>
              <div>
                <span>生产余纱处理</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWeaveEnter('4')">
              <span class="icon iconfont">&#xe795;</span>
              <div>
                <span>挂纱异常处理</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toCancelYarnDetails()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/cancel.svg" />
              <div>
                <span>纱线取消</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toYarnSupplement()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/bulu.svg" />
              <div>
                <span>纱线补录</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toRollAdd()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/bulu.svg" />
              <div>
                <span>落布卷补录</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toChangeYarnDetails()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/tiaozheng.svg" />
              <div>
                <span>纱线调整</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toWbFinish()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/finishcancel.svg" />
              <div>
                <span>丸编完成/取消</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg && bz_supplement">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toYarnAllCancel()">
              <!-- <span class="icon iconfont">&#xe7b4;</span> -->
              <img src="../assets/allcancel.svg" />
              <div>
                <span>纱线全部取消</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mui-col-sm-4 mui-col-xs-4" v-if="weaveflg">
          <div class="pd-8 nowrap">
            <div class="circle" id="orderbtn" @tap.stop.prevent="toStatistics()">
              <span class="icon iconfont">&#xe7b4;</span>
              <div>
                <span>汇总统计</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--代办事物-->
      <div class="mui-row" style="padding-bottom: 80px;">
        <h5 style="padding:8px;background-color: #FFFFFF;" class="word-font">
          代办事项
        </h5>
        <div class="mui-row pd-8" style="padding-left:20px;font-size: 12px;">
          <div class="mb-8" style="padding-left: 15px;padding-right: 5px;" v-for="(item,idx) in infoLst" :key="idx">
            <span>{{item.content}}</span>
            <a class="color-red" @tap.stop.prevent="read(item)">立即处理</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 供应商选择 -->
    <div class="gyshadow" v-show="fc_flg">
        <div class="shadow_div">
          <div class="shadow_content">
            <div class="mui-popup-title" style="text-align:left;border-top-left-radius: 5px;border-top-right-radius: 5px;" >
              <label>供应商选择</label>
            </div>
            <div class="form-input" style="text-align:center;margin:15px 5px 0px 5px;">
              <select v-model="selected_factorycd"  >
                <option :value="item.ksbh" v-for="(item,idx) in gyslist" :key="idx">{{item.ksmc}}</option>
              </select>
            </div>
            <div class="mui-popup-buttons" style="border-top:1px solid #eee;height: 45px;">
               <span class="mui-popup-button mui-popup-button-bold" @tap.stop.prevent="gsy_finish">确定</span>
            </div>
          </div>
           
        </div>
    </div>
  </section>
</template>


<script>
    export default {
        name: "home",
        data() {
          return {
            ksbh: "",
            infoLst: [],
            ucode: "",
            socketip: "",
            socketport: "",
            first_flag:true,
            uname:"",
            factorycd:"",
            gyslist:[],
            selected_factorycd:"",
            fc_flg:false,
            current_cl_el:"",
            is_tsd:0,
            enableclick:false,
            PI: 3.14159265358979324,
            x_pi: 3.14159265358979324 * 3000.0 / 180.0,
            bdLon:"",
            bdLat:"",
            ywqf:[],
            bzflg:false, // 编织业务
            hasBZ:"", // TSD人，是否拥有编织业务
            weaveflg: false, //是否为w编织
            bz_supplement: false,
            ordercnt:0
          }
        },
        methods: {
          toOrderList(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("orderList");
            }else{
              this.current_cl_el = "orderList";
              this.factory_get();
            }
          },
          toMaterial(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("material");
            }else{
              this.current_cl_el = "material";
              this.factory_get();
            }
          },
          toSampling(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("sampling");
            }else{
              this.current_cl_el = "sampling";
              this.factory_get();
            }
          },
          /*toSamplingWeaving(){
            if(this.factorycd != ""){
              this.$router.push("samplingWeaving");
            }else{
              this.current_cl_el = "samplingWeaving";
              this.factory_get();
            }
          },*/
          toQuality(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("quality");
            }else{
              this.current_cl_el = "quality";
              this.factory_get();
            }
          },
          toDelivery(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("delivery");
            }else{
              this.current_cl_el = "delivery";
              this.factory_get();
            }
          },
//           toWeChat(){
//             if(this.enableclick == false) return;
//             this.$router.push("weChat");
//             //window.location.href="/weChat.html";
//           },
          chgPwd(){
            if(this.enableclick == false) return;
            this.$router.push("chgPwd");
          },
          // 跳转到标签补打页面
          toReprintLabel(){
            if(this.enableclick == false) return;
            if(this.factorycd != ""){
              this.$router.push("label");
            }else{
              // 供应商代号不存在，先选择供应商
              this.current_cl_el = "label";
              this.factory_get();
            }
          },
          websocket: function () {
              var v = this;
              initSocket(v.nyy.wsProtocol + v.socketip + ":" + v.socketport + "/" + v.ucode, function (data) {
                  v.getMsg(function(msg_date){
                    v.infoLst = msg_date.infoLst;
                  });
              });
          },
          getMsg: function (callback) {
              var v = this;
              v.nyy.doPost("/Notify/getMsg", {}, function (result) {
                  if (result) {
                      if (result.status) {
                        if (callback) callback(result.data);
                      }
                  }
              })
          },
          read: function (item) {
              var v = this;
              v.nyy.doPost("/Notify/readMsg", { "lid": item.lid }, function (result) {
                  if (result) {
                      if (result.status) {
                          //v.getMsg(function () {
                            v.$router.push(item.linkaddr);
                          //})
                      }
                  }
              })
          },
          factory_get:function(){
             this.fc_flg = true;
          },
          gsy_finish:function(){
            if(!this.selected_factorycd){
                mui.toast("未选择供应商信息");
                return;
            }
            this.fc_flg = false;
            this.factorycd = this.selected_factorycd;
            var v = this;
            v.nyy.doPost("/Main/updGys", {"factorycd":v.factorycd},
              function(result){
                 if (result) {
                    if (result.status) {
                         if(v.current_cl_el){
                          //alert(v.current_cl_el);
                            v.$router.push(v.current_cl_el);
                         }
                       }
                    }
              });
          },
          getFac:function(){ // 供应商信息获取
              var v = this;
              v.nyy.doPost("/Main/queryGYS", {}, function (result) {
                  if (result) {
                      if (result.status) {
                          v.gyslist = result.data.infoLst;
                          if(v.gyslist && v.gyslist.length >0){
                            v.selected_factorycd = v.gyslist[0].ksbh;
                          }
                      }else {
                          mui.alert(result.message,"错误提示",function(){
                            wx.closeWindow();
                          });
                      }
                  }
              });
          },
          bd_encrypt:function(gcjLat, gcjLon){
            var v = this;
            var x = gcjLon, y = gcjLat;
            var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * v.x_pi);
            var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * v.x_pi);
            v.bdLon = z * Math.cos(theta) + 0.0065;
            v.bdLat = z * Math.sin(theta) + 0.006;
          },
          toYarn:function(){ // 挂换纱
            if(this.enableclick == false) return;

            if(this.factorycd != ""){
              this.$router.push("yarnChange");
            }
          },
          toYarnHis:function(){// 挂换纱履历
            if(this.enableclick == false) return;

            if(this.factorycd != ""){
              this.$router.push("yarnList");
            }
          },
          toCheckMachine:function(){// 巡台
            var v = this;
            if(v.enableclick == false) return;

            v.$router.push("Inspection");

            // if(v.factorycd == ""){
            //   //  mui.alert("点击了巡台","提示",function(){
                          
            //   //  });
            //   v.$router.push("Inspection");
            // }else{
            //   v.current_cl_el = "quality";
            //   // 根据当前位置获取的供应商，筛选出其中拥有编织业务的供应商
            //   var newgyslist = [];
            //   if(v.gyslist && v.gyslist.length >0){
            //     for(var i = 0;i < v.gyslist.length; i++){
            //       var gysinfo = v.gyslist[i];
            //       var temp_ywqf = ((gysinfo.ywqf) ? eval('(' + gysinfo.ywqf + ')') : []);
            //       var bzgysflg = false;
            //       if(temp_ywqf.length > 0){
            //         for(var j = 0;j<temp_ywqf.length;j++){
            //           if(temp_ywqf[j].type == 2){
            //             bzgysflg = true;
            //             break;
            //           }
            //         }
            //       }

            //       if(bzgysflg){
            //         newgyslist.push(gysinfo);
            //       }
            //     }
            //   }
            //   v.gyslist = newgyslist;
            //   v.selected_factorycd = v.gyslist[0].ksbh;
            //   // 弹出供应商选择
            //   v.factory_get();
            // }
          },
          toWarpingHistory(){ //整经履历
            this.$router.push("warpingHistoryList");
          },
          toEditHistory(){
            this.$router.push("/editHistoryList");
          },
          toWeaveEnter(val){
            this.$router.push({
              name: "weaveEnter",
              params: { 
                machineno: "",
                wph: "",
                ddh: "",
                optkind: val // 1:挂纱处理 2:挑纱 3：生产余纱处理 4：换纱异常处理 20：换纱处理
              }
            });
          },
          toStatistics(){
            this.$router.push({
              name: "aggregatestatistics",
              params: {}
            });
          },
          toWbFinish(){ // 丸编完成或取消
             this.$router.push({
              name: "wbfinish",
              params: {}
            });
          },
          toYarnAllCancel(){ // 丸编纱线全部取消
            this.$router.push({
              name: "yarnOtpEnter",
              params: {}
            });
          },
          toCancelYarnDetails() { // 丸编纱线取消
            this.$router.push({
              name: "availsForCancel",
              params: {}
            });
          },
          toYarnSupplement(){ // 丸编纱线补录处理（仅丸编完成的可补录）
            this.$router.push({
              name: "conditionEnter",
              params: {}
            });
          },
          toChangeYarnDetails() { 
            this.$router.push("/availsForChange");
          },
          toRollAdd(){ // 丸编落布卷补录
            this.$router.push({
              name: "supplementEnter",
              params: {}
            });
          },
          toTestQuality(){ // 试验反标签
            this.$router.push({
              name: "testQualityList",
              params: {}
            });
          },
          orderquery() {
            var v = this;
            v.ordercnt = 0;
            v.nyy.doPost("/Order/getOrderList", {
                ddh: "",
                scxtwpmc: "",
                contractdate_fr: "",
                contractdate_to: "",
                hyqdhrq: "",
                rawprovideflag: "",
                zt: "",
                pageSize: 0,
                pageIdx: 0,
                orderstatus: "0"
              },
              function(result) {
                if (result.status) {
                  v.ordercnt = result.data.total;
                }
              }
            );
          }
        },
        created(){
          const v = this;
          var code = this.$route.query.code;
          // v.nyy.doPost("/Main/Init", {"code":code,"latitude":0,"longitude":0},
          //             function(result) {
          //               if (result.status) {
          //                 // mui.toast(result.data.userid)
          //                 var uinfo = result.data;
          //                 v.nyy.userInfo = uinfo;
          //                 v.bz_supplement = uinfo.bz_supplement;
          //                 v.nyy.checkLogin("账号登录","",function(){
          //                   v.enableclick = true;
          //                     v.uname = uinfo.name;
          //                     v.is_tsd = uinfo.isTSD;
          //                     if(uinfo.isTSD == "1"){
          //                       v.hasBZ = uinfo.hasBZ;
          //                     }
          //                     v.ywqf = ((uinfo.ywqf) ? eval('(' + uinfo.ywqf + ')') : []);
          //                     v.bzflg = false;
          //                     if(v.ywqf.length >0){
          //                       for(var i = 0;i<v.ywqf.length;i++){
          //                         if(v.ywqf[i].type == 2){
          //                           v.bzflg = true;
          //                           break;
          //                         }
          //                       }
          //                     }
          //                     // 供应商信息
          //                     if(uinfo.factorycd){
          //                       v.factorycd = uinfo.factorycd;
          //                       v.weaveflg = uinfo.factorycd == 'CF0001' ? true : false
          //                     }else{
          //                       v.getFac();
          //                     }

          //                     // 2025.08.08 获取待确认订单数量
          //                     v.orderquery();

          //                     // 未读信息
          //                     v.getMsg(function(msg_date){
          //                       v.infoLst = msg_date.infoLst;
          //                       v.socketip = msg_date.socketip;
          //                       v.socketport = msg_date.socketport;
          //                       v.ucode = msg_date.ucode;
          //                       // 通信
          //                       /*v.websocket();*/
          //                       v.first_flag = false;
          //                     });
                              
          //                 });
          //               }
          //               else {
          //                 mui.alert(result.message,"错误提示",function(){
          //                   wx.closeWindow();
          //                 });
          //               }
          //             });
          //微信初始化
          v.nyy.wxInit(function(){
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wx.getLocation({
                  type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                  success: function (res) {
                    const latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    const longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                    const speed = res.speed; // 速度，以米/每秒计
                    const accuracy = res.accuracy; // 位置精度
                    //alert(latitude)
                    v.bd_encrypt(latitude, longitude);
                    //alert(v.bdLat + " " + v.bdLon);
                    v.nyy.doPost("/Main/Init", {"code":code,"latitude":v.bdLat,"longitude":v.bdLon},
                      function(result) {
                        if (result.status) {
                          // mui.toast(result.data.userid)
                          var uinfo = result.data;
                          v.nyy.userInfo = uinfo;
                          v.bz_supplement = uinfo.bz_supplement;
                          v.nyy.checkLogin("账号登录","",function(){
                              v.enableclick = true;
                              v.uname = uinfo.name;
                              v.is_tsd = uinfo.isTSD;
                              if(uinfo.isTSD == "1"){
                                v.hasBZ = uinfo.hasBZ;
                              }
                              v.ywqf = ((uinfo.ywqf) ? eval('(' + uinfo.ywqf + ')') : []);
                              v.bzflg = false;
                              if(v.ywqf.length >0){
                                for(var i = 0;i<v.ywqf.length;i++){
                                  if(v.ywqf[i].type == 2){
                                    v.bzflg = true;
                                    break;
                                  }
                                }
                              }
                              // 供应商信息
                              if(uinfo.factorycd){
                                v.factorycd = uinfo.factorycd;
                                v.weaveflg = uinfo.factorycd == 'CF0001' ? true : false;
                              }else{
                                v.getFac();
                              }

                              // 2025.08.08 获取待确认订单数量
                              v.orderquery();

                              if(v.is_tsd != "1"){
                                // 未读信息
                                v.getMsg(function(msg_date){
                                  v.infoLst = msg_date.infoLst;
                                  v.socketip = msg_date.socketip;
                                  v.socketport = msg_date.socketport;
                                  v.ucode = msg_date.ucode;
                                  // 通信
                                  v.websocket();
                                  v.first_flag = false;
                                });
                             }
                          });
                        }
                        else {
                          mui.alert(result.message,"错误提示",function(){
                            wx.closeWindow();
                          });
                        }
                      });
                  },
                  error:function(){
                    mui.alert("地理位置获取失败！","错误提示",function(){
                      wx.closeWindow();
                    });
                  }
                });
          });
        },
        mounted() {
          //获得slider插件对象
          let gallery = mui('.mui-slider');
          gallery.slider({
            interval:5000//自动轮播周期，若为0则不自动播放，默认为0；
          });
        },
        activated(){
          var v = this;
          if(v.first_flag == false && v.is_tsd != "1"){
            v.getMsg(function(msg_date){
              v.infoLst = msg_date.infoLst;
            });
          }
        }
    }
</script>

<style scoped>
.gyshadow {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.shadow_div{
  position: fixed; width: 100%;z-index:3;top:35%;padding:15px; border-radius: 5px;
}
.shadow_content{
  margin:0 auto;width:95%;background: #fff;border-radius: 5px;
}
.iconfont{
	color:#2F86F3;
	font-size: 25px;
}
.circle{
	text-align: center;
}
.nowrap{
  white-space: nowrap;
}
.backLine{
  height: 3px;
  background-color: #F6F6F6;
}
.iconStatus1 .iconfont{
  color: #33CCBD;
}
.iconStatus2 .iconfont{
  color: #ECAC62;
}
.badge {
  position: absolute;
    top: 0px;
    right: 40px;
    FONT-WEIGHT: 500;
    height: 10px;
    background: red;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/main.vue